module.exports = __webpack_public_path__ + "img/Wen_Gao.81ca1a91.jpg";